import { apiBackOffice, apiSimulacao } from "./utils/api";

export const getSimulations = async () => {
  const simulations = [
    {
      propspect: true,
      idCliente: 1342567,
      razaoSocial: "JOÃO NEVES MATERIAS PARA CONSTRUÇÃO",
      cnpj: "8302494000170",
      segmentoDesc: "VC-VAREJO_M",
      simulador: "ENSACADOS",
      grupoCentralizador: null,
      createdAt: "25/11/2023-14:23",
      endereco: "Rua Loefgreen nº 31 Vila Clementino",
      trilhaGlobal: "AC",
      telefone: "(11)3681-0777",
      micro: "VC-São Paulo",
      cidade: "São Paulo",
      cluster: "ZONA SUL",
      beneficioFiscal: "Suflama",
    },
    {
      propspect: true,
      idCliente: 1342568,
      razaoSocial: "JOÃO PEDRO AZULEJOS",
      cnpj: "8302494000170",
      segmentoDesc: "VC-VAREJO_M",
      simulador: "ENSACADOS",
      grupoCentralizador: null,
      createdAt: "23/09/2023-14:23",
      endereco: "Rua Loefgreen nº 31 Vila Clementino",
      trilhaGlobal: "AC",
      telefone: "(11)3681-0777",
      micro: "VC-São Paulo",
      cidade: "São Paulo",
      cluster: "ZONA SUL",
      beneficioFiscal: "Suflama",
    },
    {
      propspect: true,
      idCliente: 163941,
      razaoSocial: "TRIANGULO MATERIAS DE CONSTRUÇÃO LT",
      cnpj: "8302494000170",
      segmentoDesc: "VC-VAREJO_P",
      simulador: "IMO CONCRETO",
      grupoCentralizador: null,
      createdAt: "24/10/2023-13:10",
      endereco: "Rua Loefgreen nº 31 Vila Clementino",
      trilhaGlobal: "AC",
      telefone: "(11)3681-0777",
      micro: "VC-São Paulo",
      cidade: "São Paulo",
      cluster: "ZONA SUL",
      beneficioFiscal: "Suflama",
    },
    {
      propspect: false,
      idCliente: 1366316,
      razaoSocial: "IKEDA FERRAGENS LTDA",
      cnpj: "8302494000170",
      segmentoDesc: "VC-VAREJO_M",
      simulador: "ENSACADOS",
      grupoCentralizador: "IKEDA",
      createdAt: "07/10/2023-11:28",
      endereco: "Rua Loefgreen nº 31 Vila Clementino",
      trilhaGlobal: "AC",
      telefone: "(11)3681-0777",
      micro: "VC-São Paulo",
      cidade: "São Paulo",
      cluster: "ZONA SUL",
      beneficioFiscal: "Suflama",
    },
    {
      propspect: false,
      idCliente: 1148933,
      razaoSocial: "CONSTRUCASA TABOAO MATERIAL DE CON.",
      cnpj: "8302494000170",
      segmentoDesc: "VC-VAREJO_P",
      simulador: "CIM GRANEL",
      grupoCentralizador: "CONSTRUCASA",
      createdAt: "06/10/2023-17:15",
      endereco: "Rua Loefgreen nº 31 Vila Clementino",
      trilhaGlobal: "AC",
      telefone: "(11)3681-0777",
      micro: "VC-São Paulo",
      cidade: "São Paulo",
      cluster: "ZONA SUL",
      beneficioFiscal: "Suflama",
    },
    {
      propspect: false,
      idCliente: 2948933,
      razaoSocial: "CONSTRUÇÃO PÉ NA AREIA.",
      cnpj: "8302494000170",
      segmentoDesc: "VC-VAREJO_P",
      simulador: "CIM GRANEL",
      grupoCentralizador: "CONSTRUCASA",
      createdAt: "06/11/2023-17:15",
      endereco: "Rua Loefgreen nº 31 Vila Clementino",
      trilhaGlobal: "AC",
      telefone: "(11)3681-0777",
      micro: "VC-São Paulo",
      cidade: "São Paulo",
      cluster: "ZONA SUL",
      beneficioFiscal: "Suflama",
    },
  ];
  return simulations;
};

export const getClients = async () => {
  const clients = [
    {
      idCliente: 1342567,
      razaoSocial: "JOÃO NEVES MATERIAS PARA CONSTRUÇÃO",
    },
    {
      idCliente: 163941,
      razaoSocial: "TRIANGULO MATERIAS DE CONSTRUÇÃO LT",
    },
    {
      idCliente: 1366316,
      razaoSocial: "IKEDA FERRAGENS LTDA",
    },
    {
      idCliente: 1148933,
      razaoSocial: "CONSTRUCASA TABOAO MATERIAL DE CON.",
    },
    {
      idCliente: 2948933,
      razaoSocial: "CONSTRUÇÃO PÉ NA AREIA.",
    },
    {
      idCliente: 1342568,
      razaoSocial: "JOÃO PEDRO AZULEJOS",
    },
  ];
  return clients;
};

export const getClientById = async (idCliente) => {
  const clientById = {
    idCliente: 1342567,
    razaoSocial: "JOÃO NEVES MATERIAS PARA CONSTRUÇÃO",
    endereco: "Rua Loefgreen nº 31 Vila Clementino",
    trilhaGlobal: "AC",
    segmentoDesc: "VC VAREJO M",
    telefone: "(11)3681-0777",
    micro: "VC-São Paulo",
    cidade: "São Paulo",
    cluster: "ZONA SUL",
    beneficioFiscal: "Suflama",
  };
  return clientById;
};

export const getProdutcsFromSimulation = async (idCliente) => {
  await new Promise((resolve) => setTimeout(resolve, 1000));
  const productsFromSimulation = [
    {
      id: 1,
      grupoProdutos: "Colantes",
      sku: "Arga cerâmica interna (ACI)-20KG",
      statusAprovacao: "Condição especial não enviada",
      aprovador: "Giulia Marcucci",
      centro: {
        id: 12,
        name: "CD-Bauru",
      },
      prazoPagamento: "15 Dias",
      fob: {
        precoFinalFob: 28.9,
        precoRegra: 15.9,
        desconto: 1.2,
        descontoFaixa: "-1,0 %",
        fracionamento: 0.2,
        descarga: 0,
        beneficioFiscal: 0,
        precoFinal: 14.7,
      },
      cif: {
        precoFinalCif: 30.9,
        precoRegra: 15.9,
        desconto: 1.0,
        descontoFaixa: "-1,0 %",
        fracionamento: 0.2,
        descarga: 0,
        beneficioFiscal: 0,
        precoFinal: 16.9,
      },
    },
    {
      id: 2,
      grupoProdutos: "Colantes",
      sku: "Arga cerâmica externa (ACI)-20KG",
      statusAprovacao: "Condição especial não enviada",
      aprovador: "Giulia Marcucci",
      centro: {
        id: 12,
        name: "CD-Bauru",
      },
      prazoPagamento: "15 Dias",
      fob: {
        precoFinalFob: 28.9,
        precoRegra: 15.9,
        desconto: 1.2,
        descontoFaixa: "-1,0 %",
        fracionamento: 0.2,
        descarga: 0,
        beneficioFiscal: 0,
        precoFinal: 14.7,
      },
      cif: {
        precoFinalCif: 30.9,
        precoRegra: 15.9,
        desconto: 1.0,
        descontoFaixa: "-1,0 %",
        fracionamento: 0.2,
        descarga: 0,
        beneficioFiscal: 0,
        precoFinal: 16.9,
      },
    },
    {
      id: 3,
      grupoProdutos: "Cimentos",
      sku: "Todas as obras Poty CPIII 32 R$ 50KG",
      statusAprovacao: "Aprovado",
      // aprovador: "Giulia Marcucci",
      centro: {
        id: 1,
        name: "CD-Diadema",
      },
      prazoPagamento: "15 Dias",
      fob: {
        precoFinalFob: 28.9,
        precoRegra: 15.9,
        desconto: 1.2,
        descontoFaixa: "-1,0 %",
        fracionamento: 0.2,
        descarga: 0,
        beneficioFiscal: 0,
        precoFinal: 14.7,
      },
      cif: {
        precoFinalCif: 30.9,
        precoRegra: 15.9,
        desconto: 1.0,
        descontoFaixa: "-1,0 %",
        fracionamento: 0.2,
        descarga: 0,
        beneficioFiscal: 0,
        precoFinal: 16.9,
      },
    },
    {
      id: 4,
      grupoProdutos: "Rejunte",
      sku: "Rejunte",
      statusAprovacao: "Faixa não enviada",
      aprovador: "Giulia Marcucci",
      centro: {
        id: 1,
        name: "CD-Diadema",
      },
      prazoPagamento: "15 Dias",
      fob: {
        precoFinalFob: 28.9,
        precoRegra: 15.9,
        desconto: 1.2,
        descontoFaixa: "-1,0 %",
        fracionamento: 0.2,
        descarga: 0,
        beneficioFiscal: 0,
        precoFinal: 14.7,
      },
      cif: {
        precoFinalCif: 30.9,
        precoRegra: 15.9,
        desconto: 1.0,
        descontoFaixa: "-1,0 %",
        fracionamento: 0.2,
        descarga: 0,
        beneficioFiscal: 0,
        precoFinal: 16.9,
      },
    },
  ];
  return productsFromSimulation;
};

export const getSimulationsByClient = async (idCliente) => {
  // Mock espera da API
  await new Promise((resolve) => setTimeout(resolve, 1000));
  const simulationsByClient = [
    {
      idSimulacao: 1342567,
      simuladorTipo: "Ensacados",
      data: "2024-01-10 14:30:28",
      produtos: [
        {
          quantidade: 1,
          nome: "Cimento",
        },
        {
          quantidade: 2,
          nome: "Colantes",
        },
        {
          quantidade: 6,
          nome: "Rejuntes",
        },
      ],
    },
    {
      idSimulacao: 1345567,
      simuladorTipo: "Ensacados",
      data: "2024-01-08 15:32:28",
      produtos: [
        {
          quantidade: 2,
          nome: "Cimento",
        },
        {
          quantidade: 2,
          nome: "Colantes",
        },
      ],
    },
    {
      idSimulacao: 1342567,
      simuladorTipo: "Ensacados",
      data: "2023-12-20 14:30:28",
      produtos: [
        {
          quantidade: 25,
          nome: "Cimento",
        },
      ],
    },
  ];
  return simulationsByClient;
};

export const getSimulacoes = async (skip, take, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiSimulacao.get(`/api/Simulacao`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response);
  return res;
}

export const getPrecosRegra = async (skip, take, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiSimulacao.get(`/api/TabelaPreco`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response.data);
  return res;
}

export const getPrecosCliente = async (skip, take, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiSimulacao.get(`/api/TabelaPreco/PrecosCliente`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response.data);
  return res;
}

export const getNegociacoesPrecosRegra = async () => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiSimulacao.get(`/api/TabelaPreco/Negociacoes`, { params: { take: 0 } }).then((response) => response.data);
  return res;
}

export const getSimuladorSolicitacoes = async () => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiSimulacao.get(`/api/Simulacao/Solicitacoes`, { params: { take: 0 } }).then((response) => response.data);
  return res;
}

export const getHierarquiasAprovacao = async (skip, take, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/HierarquiaAprovacao`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response.data);
  return res;
}

export const salvarRenovacao = async (camposRenovacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiSimulacao.post('/api/TabelaPreco/Renovar', camposRenovacao).then((response) => {
    if (response.data === undefined) return response;
    return response.data;
  });
  return res;
};

export const sendCompartilharSimulacao = async (simulacaoId, email, attachment) => {
  const formData = new FormData();
  formData.append('attachment', attachment);

  const res = await apiSimulacao.post(`/api/Simulacao/Compartilhar/${simulacaoId}`, formData,
    {
      headers: { 'Content-Type': "multipart/form-data" },
      params: { email: email }
  }).then((response) => response.data);

  return res;
}